const eventType = { authenticatedUser: 'authenticatedUser' };

export const isReactNativeWrappedApp = () =>
  typeof window !== 'undefined' && window.ReactNativeWebView;

/**
 * @param {object} params
 * @param {keyof typeof eventType} params.eventType
 * @param {object} params.data
 */
export const sendDataToReactNativeApp = params => {
  const { eventType: type, data: d } = params;
  if (isReactNativeWrappedApp()) {
    const data = JSON.stringify({
      ...d,
      eventType: eventType[type],
    });
    window.ReactNativeWebView.postMessage(data);
  }
};
